import type * as React from 'react';
import { LocaleToggle } from '@/components/LocaleToggle';
import { AgencySwitcher } from '@/components/topbar/AgencySwitcher';
import { AnnouncementsButton } from '@/components/topbar/AnnouncementsButton';
import { GlobalSearch } from '@/components/topbar/GlobalSearch';
import { NotificationsBell } from '@/components/topbar/NotificationsBell';
import { MobileNavButton } from './MobileNav';

/**
 * The top bar: global search on the left, then the language, the notifications bell and the agency
 * (docs/estilo-visual.md §Layout; change spec 2026-09-24/topbar). At 390 px: hamburger, a search button
 * that shrinks to fit, EN/ES, the announcements megaphone (fleet-driver-pay T5.3), the bell, and the agency switcher's icon only for a multi-agency member.
 */
export function Topbar({
  menu,
}: {
  /** The phone drawer's hamburger (below md only). */
  menu?: { open: boolean; onOpen: () => void; buttonRef: React.Ref<HTMLButtonElement> };
}) {
  return (
    <header className="sticky top-0 z-(--z-sticky) flex h-16 shrink-0 items-center gap-2 border-b border-hairline bg-card px-4 sm:gap-4 md:px-6">
      {menu && <MobileNavButton open={menu.open} onOpen={menu.onOpen} buttonRef={menu.buttonRef} />}
      <div className="min-w-0 flex-1 md:max-w-xl">
        <GlobalSearch />
      </div>

      <div className="ml-auto flex shrink-0 items-center gap-1 sm:gap-2">
        <LocaleToggle />
        <AnnouncementsButton />
        <NotificationsBell />
        <AgencySwitcher />
      </div>
    </header>
  );
}
